import { get } from '../../shared/services/http.service';

export const getPlatforms = async (applicationId: number) => {
  return get(`/applications/${applicationId}/platforms`);
};

export default getPlatforms;
